import PropTypes from 'prop-types';
import useLocalize from '../../../utils/hooks/useLocalize';
import { formatFieldValue, getFieldLabel } from '../../../utils/scan';
import './ScanCardFields.scss';

/**
 * ScanCardFields component - displays the scan fields/settings
 * @param {Array} fields - Array of field objects with id, type and values
 * @returns React component that renders the fields section
 */
const ScanCardFields = ({ fields }) => {
  const localize = useLocalize();

  /**
   * Generate scan settings nodes from fields.
   * Each field is rendered as "{label}: {valueText}" separated by commas.
   */
  const mapFields = () => {
    if (!fields || fields.length === 0) {
      return null;
    }

    return fields.map((field, index) => {
      const label = getFieldLabel(field.id, localize);
      const formatted = formatFieldValue(field, localize);
      const valueText = formatted ?? '-';
      const separator = index > 0 ? ', ' : '';
      return (
        <span key={field.id ?? index}>
          {separator}
          <span className="scan-card-fields-label">{label}</span>
          {`: ${valueText}`}
        </span>
      );
    });
  };

  return (
    <div className="scan-card-fields">
      <span className="scan-card-fields-text">{mapFields()}</span>
    </div>
  );
};

ScanCardFields.propTypes = {
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      type: PropTypes.oneOf(['range', 'select', 'multiselect']),
      values: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      )
    })
  )
};

export default ScanCardFields;
